import {UU_FAILURE, UU_PENDING, UU_SUCCESS} from './constants'
import {updateUser} from '../../../services/user'

export async function updateUserData(dispatch, params) {
  try {
    dispatch({type: UU_PENDING})
    const response = await updateUser(params)
    dispatch({type: UU_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: UU_FAILURE, payload: e})
  }
}
